// extracted by mini-css-extract-plugin
export default {"header":"N5e9Q2RI","video":"kMhwvPzb","title":"mIipQvXi"};